import { lazy, Suspense } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';

import ImageFingerprintsPage from './layouts/v2/pages/mail-automation/ImageFingerprintsPage';
import MailAutomationSettingsPage from './layouts/v2/pages/mail-automation/MailAutomationSettingsPage';
import WorkflowDetailPage from './layouts/v2/pages/mail-automation/WorkflowDetailPage';
import WorkflowRunsDetailPage from './layouts/v2/pages/mail-automation/WorkflowRunsDetailPage';
import WorkflowRunsPage from './layouts/v2/pages/mail-automation/WorkflowRunsPage';
import WorkflowsPage from './layouts/v2/pages/mail-automation/WorkflowsPage';

const DashboardPage = lazy(
  () => import('$pages/dashboard/dashboard/DashboardPage'),
);
const StatsPage = lazy(() => import('$pages/dashboard/stats/StatsPage'));
const HomePage = lazy(() => import('$pages/dashboard/home/HomePage'));
const BookingDetailPage = lazy(
  () => import('$pages/operations/booking_detail/BookingDetailPage'),
);
const BookingsPage = lazy(
  () => import('$pages/operations/bookings/BookingsPage'),
);
const ClientDetailPage = lazy(
  () => import('$pages/identity/client_detail/ClientDetailPage'),
);
const ClientsPage = lazy(() => import('$pages/identity/clients/ClientsPage'));
const ClientApiDetailPage = lazy(
  () => import('$pages/identity/clients_api_detail/clientApiDetail'),
);
const ClientApiPage = lazy(
  () => import('$pages/identity/clients_api/clientsApiPage'),
);
const ContractDetailPage = lazy(
  () => import('$pages/commercial/contract_detail/ContractDetailPage'),
);
const ContractsPage = lazy(
  () => import('$pages/commercial/contracts/ContractsPage'),
);
const EmissionReportsAllPage = lazy(
  () => import('$pages/reporting/emission_reports_all/EmissionReportsAllPage'),
);
const EmissionReportsDetailPage = lazy(
  () =>
    import(
      '$pages/reporting/emission_reports_detail/EmissionReportsDetailPage'
    ),
);
const EmissionReportsFailedPage = lazy(
  () =>
    import(
      '$pages/reporting/emission_reports_failed/EmissionReportsFailedPage'
    ),
);
const EmissionReportsPage = lazy(
  () => import('$pages/reporting/emission_reports/EmissionReportsPage'),
);
const EmissionReportsProcessingPage = lazy(
  () =>
    import(
      '$pages/reporting/emission_reports_processing/EmissionReportsProcessingPage'
    ),
);
const EmissionReportsOrphanedPage = lazy(
  () =>
    import(
      '$pages/reporting/emission_reports_orphaned/EmissionReportsOrphanedPage'
    ),
);
const EventDetailPage = lazy(
  () => import('$pages/operations/event_detail/EventDetailPage'),
);
const EventsPage = lazy(() => import('$pages/operations/events/EventsPage'));
const FeaturesPage = lazy(
  () => import('$pages/administration/features/FeaturesPage'),
);
const FleetMapPage = lazy(() => import('$pages/operations/fleet/FleetMapPage'));
const LocationDetailPage = lazy(
  () => import('$pages/identity/location_detail/LocationDetailPage'),
);
const LocationsPage = lazy(
  () => import('$pages/identity/locations/LocationsPage'),
);
const AddressDetailPage = lazy(
  () => import('$pages/identity/address_detail/AddressDetailPage'),
);
const AddressesPage = lazy(
  () => import('$pages/identity/addresses/AddressesPage'),
);
const MailClassificationDashboard = lazy(
  () => import('$pages/ai/mail_classification/MailClassificationDashboard'),
);
const MailAutomationOverviewPage = lazy(
  () => import('$pages/mail-automation/MailAutomationOverviewPage'),
);
const EmailDetailPage = lazy(
  () => import('$pages/ai/mail_classification_detail/EmailDetailPage'),
);
const MaintenancePage = lazy(
  () => import('$pages/administration/maintenance/MaintenancePage'),
);
const NonConformityDetailPage = lazy(
  () =>
    import('$pages/commercial/non_conformity_detail/NonConformityDetailPage'),
);
const NonConformitiesPage = lazy(
  () => import('$pages/commercial/non-conformitie/NonConformitiesPage'),
);
const OrderDetailPage = lazy(
  () => import('$pages/commercial/order_detail/OrderDetailPage'),
);
const OrdersPage = lazy(() => import('$pages/commercial/orders/OrdersPage'));
const BIReportDetailPage = lazy(
  () => import('./layouts/v2/pages/bi-reports/BIReportDetailPage'),
);
const BIReportsPage = lazy(
  () => import('./layouts/v2/pages/bi-reports/BIReportsPage'),
);
const QuotationDetailPage = lazy(
  () => import('$pages/commercial/quotation_detail/QuotationDetailPage'),
);
const QuotationsPage = lazy(
  () => import('$pages/commercial/quotations/QuotationsPage'),
);
const QuoteRequestDetailPage = lazy(
  () => import('$pages/commercial/quote_request_detail/QuoteRequestDetailPage'),
);
const QuoteRequestsPage = lazy(
  () => import('$pages/commercial/quoteRequests/QuoteRequestsPage'),
);
const RatingsPage = lazy(
  () => import('$pages/administration/ratings/ratingsPage'),
);
const ReleaseNotesDetailPage = lazy(
  () =>
    import('$pages/administration/release_notes_detail/ReleaseNotesDetailPage'),
);
const ReleaseNotesPage = lazy(
  () => import('$pages/administration/releaseNotes/ReleaseNotesPage'),
);
const ScrapedEmailDetailPage = lazy(
  () => import('$pages/mail-automation/scraped-emails/ScrapedEmailDetailPage'),
);
const ScrapedEmailsPage = lazy(
  () => import('$pages/mail-automation/scraped-emails/ScrapedEmailsPage'),
);
const ProcessedEmailDetailPage = lazy(
  () =>
    import('$pages/mail-automation/processed-emails/ProcessedEmailDetailPage'),
);
const ProcessedEmailsMailboxesPage = lazy(
  () =>
    import(
      '$pages/mail-automation/processed-emails/ProcessedEmailsMailboxesPage'
    ),
);
const ProcessedEmailsPage = lazy(
  () => import('$pages/mail-automation/processed-emails/ProcessedEmailsPage'),
);
const ShipmentDetailPage = lazy(
  () => import('$pages/operations/shipment_detail/ShipmentDetailPage'),
);
const ShipmentsPage = lazy(
  () => import('$pages/operations/shipments/ShipmentsPage'),
);
const TermsAndConditionsCreatePage = lazy(
  () =>
    import(
      '$pages/administration/terms_and_conditions_create/TermsAndConditionsCreatePage'
    ),
);
const TermsAndConditionsDetailPage = lazy(
  () =>
    import(
      '$pages/administration/terms_and_conditions_detail/TermsAndConditionsDetailPage'
    ),
);
const TermsAndConditionsPage = lazy(
  () =>
    import('$pages/administration/terms_and_conditions/TermsAndConditionsPage'),
);
const UserDetailPage = lazy(
  () => import('$pages/identity/user_detail/UserDetailPage'),
);
const UsersPage = lazy(() => import('$pages/identity/users/UsersPage'));
export default function RouterV2() {
  const routes = useRoutes([
    {
      path: '/v2',
      children: [
        {
          path: 'dashboard',
          children: [
            {
              index: true,
              element: <DashboardPage />,
            },
            {
              path: 'home',
              element: <HomePage />,
            },
            {
              path: 'stats',
              element: <StatsPage />,
            },
            {
              path: 'bi-reports',
              children: [
                {
                  index: true,
                  element: <BIReportsPage />,
                },
                {
                  path: ':id',
                  element: <BIReportDetailPage />,
                },
              ],
            },
            {
              path: 'emission-reports',
              children: [
                {
                  path: 'completed',
                  element: <EmissionReportsPage />,
                },
                {
                  path: 'failed',
                  element: <EmissionReportsFailedPage />,
                },
                {
                  path: 'processing',
                  element: <EmissionReportsProcessingPage />,
                },
                {
                  path: 'all',
                  element: <EmissionReportsAllPage />,
                },
                {
                  path: 'orphaned',
                  element: <EmissionReportsOrphanedPage />,
                },
                {
                  path: ':id/:client_id',
                  element: <EmissionReportsDetailPage />,
                },
              ],
            },
            {
              path: 'users',
              children: [
                { index: true, element: <UsersPage /> },
                { path: ':id', element: <UserDetailPage /> },
              ],
            },
            {
              path: 'clients',
              children: [
                { index: true, element: <ClientsPage /> },
                { path: ':id', element: <ClientDetailPage /> },
              ],
            },
            {
              path: 'locations',
              children: [
                { index: true, element: <LocationsPage /> },
                { path: ':id', element: <LocationDetailPage /> },
              ],
            },
            {
              path: 'addresses',
              children: [
                { index: true, element: <AddressesPage /> },
                { path: ':id/:client_id', element: <AddressDetailPage /> },
              ],
            },
            {
              path: 'client-api',
              children: [
                { index: true, element: <ClientApiPage /> },
                { path: ':id', element: <ClientApiDetailPage /> },
              ],
            },
            {
              path: 'terms-and-conditions',
              children: [
                { index: true, element: <TermsAndConditionsPage /> },
                { path: 'new', element: <TermsAndConditionsCreatePage /> },
                { path: ':id', element: <TermsAndConditionsDetailPage /> },
              ],
            },
            {
              path: 'events',
              children: [
                { index: true, element: <EventsPage /> },
                { path: ':id', element: <EventDetailPage /> },
              ],
            },
            {
              path: 'bookings',
              children: [
                { index: true, element: <BookingsPage /> },
                { path: ':id/:client_id', element: <BookingDetailPage /> },
              ],
            },
            {
              path: 'shipments',
              children: [
                { index: true, element: <ShipmentsPage /> },
                { path: ':id/:client_id', element: <ShipmentDetailPage /> },
              ],
            },
            {
              path: 'fleet',
              element: <FleetMapPage />,
            },
            {
              path: 'quotations',
              children: [
                { index: true, element: <QuotationsPage /> },
                { path: ':id/:client_id', element: <QuotationDetailPage /> },
              ],
            },
            {
              path: 'quoteRequests',
              children: [
                { index: true, element: <QuoteRequestsPage /> },
                { path: ':id/:client_id', element: <QuoteRequestDetailPage /> },
              ],
            },
            {
              path: 'contracts',
              children: [
                { index: true, element: <ContractsPage /> },
                { path: ':id/:client_id', element: <ContractDetailPage /> },
              ],
            },
            {
              path: 'orders',
              children: [
                { index: true, element: <OrdersPage /> },
                { path: ':id/:client_id', element: <OrderDetailPage /> },
              ],
            },
            {
              path: 'offers',
              children: [
                { index: true, element: <OrdersPage /> },
                { path: ':id/:client_id', element: <OrderDetailPage /> },
              ],
            },
            {
              path: 'non-conformities',
              children: [
                { index: true, element: <NonConformitiesPage /> },
                {
                  path: ':id/:client_id',
                  element: <NonConformityDetailPage />,
                },
              ],
            },
            {
              path: 'ratings',
              element: <RatingsPage />,
            },
            {
              path: 'maintenance',
              element: <MaintenancePage />,
            },
            {
              path: 'features',
              element: <FeaturesPage />,
            },
            {
              path: 'release-notes',
              children: [
                { index: true, element: <ReleaseNotesPage /> },
                { path: 'create', element: <ReleaseNotesDetailPage /> },
                { path: ':id', element: <ReleaseNotesDetailPage /> },
              ],
            },
            {
              path: 'ai-experiments',
              element: <Navigate to="mail-classification" replace />,
            },
            {
              path: 'ai-experiments/mail-classification',
              children: [
                { index: true, element: <MailClassificationDashboard /> },
                { path: ':id', element: <EmailDetailPage /> },
              ],
            },
            {
              path: 'mail-automation/scraped-emails',
              children: [
                { index: true, element: <ScrapedEmailsPage /> },
                { path: ':id', element: <ScrapedEmailDetailPage /> },
              ],
            },
            {
              path: 'mail-automation/processed-emails',
              children: [
                { index: true, element: <ProcessedEmailsMailboxesPage /> },
                { path: 'detail/:id', element: <ProcessedEmailDetailPage /> },
                { path: ':mailbox', element: <ProcessedEmailsPage /> },
              ],
            },
          ],
        },
        {
          path: 'mail-automation',
          children: [
            {
              index: true,
              element: <MailAutomationOverviewPage />,
            },
            {
              path: 'workflows',
              children: [
                {
                  index: true,
                  element: <WorkflowsPage />,
                },
                {
                  path: ':workflowId/versions/:version',
                  element: <WorkflowDetailPage />,
                },
                {
                  path: ':workflowId',
                  element: <WorkflowDetailPage />,
                },
              ],
            },
            {
              path: 'workflow-runs',
              children: [
                {
                  index: true,
                  element: <WorkflowRunsPage />,
                },
                {
                  path: ':workflowRunId',
                  element: <WorkflowRunsDetailPage />,
                },
              ],
            },
            {
              path: 'ignored-images',
              element: <ImageFingerprintsPage />,
            },
            {
              path: 'settings',
              element: <MailAutomationSettingsPage />,
            },
          ],
        },
      ],
    },
    // Keep unknown URLs inside the v2 application.
    { path: '*', element: <Navigate to="/v2/dashboard" replace /> },
  ]);

  return <Suspense fallback={<div>Loading…</div>}>{routes}</Suspense>;
}
